<template>
  <section>
    <h2 class="headline">Отзывы о компаниях{{ review_suffix }}</h2>
    <v-container class="reviews" grid-list-xl>
      <Review
        v-for="item in reviews"
        :item="item"
        :initOpened="true"
        :companyNameSuf="review_suffix"
      />
    </v-container>
  </section>
</template>

<script>

import { mapState } from 'vuex';

import "../../scss/components/Reviews.scss"
import { defineAsyncComponent } from 'vue'

export default {
  name: "LandingReviews",
  components: {
    Review: defineAsyncComponent(() => import("../../components/Review.vue")),
  },
  computed: mapState({
    review_suffix: (state) => (state.LandingM.city_name? ` в ${state.LandingM.city_name}`:''),
    reviews: (state) => state.LandingM.reviews,
  }),
};
</script>
